import {AreaSupervisor} from '../admin/area-supervisor.model';
import {StoreDetails} from '../stores/store-details.model';
import {PurposeAction} from './purpose.model';

export class ScheduleModel {
  id: string;
  merchandiserId: number;
  areaSupervisorId: number;
  areaSupervisor?: AreaSupervisor;
  retailerId: number;
  retailer?: StoreDetails;
  scheduledDate: Date;
  scheduledOutlookDate: Date;
  isAllDayEvent: boolean;
  appointmentName?: string;
  appointmentNotes?: string;
  scheduleType: string;
  formVersionId?: number;
  isRevisionAudit?: boolean;
  formStatus: number;
  territoryNumber: number;
  purposeActions: PurposeAction[];
  onBehalfOf?: string;
  syncToMsOutlook?: boolean;
  scheduledDateStartOfDay?: Date;
  scheduledDateEndOfDay?: Date;
}

export enum ScheduleType {
  AUDIT = 'Audit',
  REVISION = 'Revision',
  TRAINING = 'Training',
  TRAINING_UK = 'WorkWith',
  APPOINTMENT = 'Appointment'
}

export enum ScheduleFormType {
  AUDIT = 'Audit',
  AUDIT_CVS = 'Audit_CVS',
  REVISION_AUDIT = 'Revision_Audit',
  REVISION_AUDIT_CVS = 'Revision_Audit_CVS',
  TRAINING = 'Training'
}

export namespace ScheduleFormType {
  export function isRevisionAudit(value: ScheduleFormType): boolean {
    return value === ScheduleFormType.REVISION_AUDIT || value === ScheduleFormType.REVISION_AUDIT_CVS;
  }

  export function isAudit(value: ScheduleFormType): boolean {
    return value === ScheduleFormType.AUDIT || value === ScheduleFormType.AUDIT_CVS;
  }
}

export namespace ScheduleType {
  export function isRevisionAudit(value: ScheduleType): boolean {
    return value === ScheduleType.REVISION;
  }

  export function isAudit(value: ScheduleType): boolean {
    return value === ScheduleType.AUDIT;
  }

  export function isTraining(value: ScheduleType): boolean {
    return value === ScheduleType.TRAINING;
  }
}

export const ScheduleEventTypeOptions_US =  [
  { text: 'Appointment', value: ScheduleType.APPOINTMENT },
  { text: 'Training', value: ScheduleType.TRAINING },
  { text: 'Audit', value: ScheduleType.AUDIT },
  { text: 'Revision Audit', value: ScheduleType.REVISION }
];

export const ScheduleEventTypeOptions_UK =  [
  { text: 'Appointment', value: ScheduleType.APPOINTMENT },
  { text: 'Training', value: ScheduleType.TRAINING },
  { text: 'Audit', value: ScheduleType.AUDIT }
];
